module.exports = __webpack_public_path__ + "static/media/copyClipboard_enabled.73e512d0.svg";